import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';

export default function OrderTable({ row }) {
  return (
    <Box
      sx={{
        height: '65vh',
        width: '100%'
      }}>
      <DataGrid
        rowHeight={40}
        headerHeight={35}
        rows={row}
        columns={[
          {
            field: 'VendorName',
            headerName: 'Vendor',
            flex: 1,
            minWidth: 140
          },
          {
            field: 'CostPr',
            headerName: 'Rates',
            type: 'number',
            width: 80,
            align: 'right',
            headerAlign: 'right',
            valueGetter: (params) => Number(params.value ?? 0)
          }
        ]}
        getRowId={(row) => row.id}
        sx={{
          border: '1px solid #3498db',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#3498db !important',
            color: 'white'
          }
        }}
        hideFooter
      />
    </Box>
  );
}
